/*
  Queen's stores page behaviour, ported for Dawn
  ==============================================

  Ported verbatim from copyofqueen1-theme/assets/petplus-stores.js. The
  parsing, the Africa/Johannesburg open/closed calculation, the WhatsApp
  number derivation and the tablist keyboard handling are all unchanged -
  only the icons differ.

  Queen draws them with FontAwesome (<i class="fa fa-whatsapp">), which Dawn
  does not ship. They are inline SVG here, keeping the `fa` class so every
  existing rule in queen-stores.css still applies, and sized in `em` with
  fill:currentColor so the `color`, `font-size`, `opacity` and `transform`
  those rules set all behave exactly as before.
*/

(function () {
var ICONS = {
  whatsapp:
    '<svg class="fa" viewBox="0 0 24 24" aria-hidden="true"><path d="M12.04 2A9.9 9.9 0 0 0 2.1 11.9c0 1.75.46 3.46 1.34 4.97L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01a9.9 9.9 0 0 0 9.9-9.9A9.9 9.9 0 0 0 12.04 2Zm5.8 14.06c-.24.68-1.4 1.3-1.95 1.34-.5.04-.98.22-3.32-.7-2.8-1.1-4.58-3.96-4.72-4.14-.14-.19-1.13-1.5-1.13-2.86 0-1.36.71-2.03.96-2.3.25-.28.55-.35.73-.35h.52c.17 0 .4-.06.62.48.24.57.8 1.98.87 2.12.07.14.12.3.02.49-.1.19-.14.3-.28.47-.14.16-.3.36-.42.48-.14.14-.29.3-.12.58.16.29.72 1.19 1.55 1.93 1.07.95 1.97 1.25 2.25 1.39.28.14.45.12.61-.07.17-.19.71-.83.9-1.11.19-.29.37-.24.63-.14.25.09 1.66.78 1.94.93.29.14.48.21.55.33.07.12.07.68-.17 1.35Z"/></svg>',
  directions:
    '<svg class="fa" viewBox="0 0 24 24" aria-hidden="true"><path d="M21.4 2.6a1 1 0 0 0-1.05-.23l-17 6.5a1 1 0 0 0 .06 1.88l7.2 2.32 2.32 7.2a1 1 0 0 0 1.88.06l6.5-17a1 1 0 0 0-.21-1.06Z"/></svg>',
  pin:
    '<svg class="fa" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5.05 6.24 12.31 6.5 12.62a.67.67 0 0 0 1 0C12.76 21.31 19 14.05 19 9a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5Z"/></svg>',
  headset:
    '<svg class="fa" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a9 9 0 0 0-9 9v5a3 3 0 0 0 3 3h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H5v-1a7 7 0 0 1 14 0v1h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1a3 3 0 0 0 3-3v-5a9 9 0 0 0-9-9Z"/></svg>',
  chevron:
    '<svg class="fa" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
};

  var STORE_LOCATIONS = {
    plumstead: {
      embedUrl: "https://www.google.com/maps?q=-34.018027,18.4647821&z=18&output=embed",
      directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=-34.018027,18.4647821"
    }
  };

  function slugify(value) {
    return value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  }

  function addActions(details, location) {
    var actions = document.createElement("div");
    var phone = details.textContent.match(/(?:0\d{2})\s*\d{3}\s*\d{4}/);
    var mapLink = details.querySelector('a[href*="g.page"], a[href*="maps"]');
    if (location) {
      if (!mapLink) mapLink = document.createElement("a");
      mapLink.href = location.directionsUrl;
    }
    actions.className = "pp-store__actions";
    if (phone) {
      var phoneNumber = phone[0].replace(/\D/g, "");
      var whatsappNumber = phoneNumber.charAt(0) === "0" ? "27" + phoneNumber.slice(1) : phoneNumber;
      var call = document.createElement("a");
      call.className = "pp-store__action pp-store__action--primary";
      call.href = "https://wa.me/" + whatsappNumber;
      call.setAttribute("target", "_blank");
      call.setAttribute("rel", "noopener");
      call.innerHTML = ICONS.whatsapp + '<span>Whatsapp Store</span>';
      actions.appendChild(call);
    }
    if (mapLink) {
      mapLink.className = "pp-store__action";
      mapLink.innerHTML = ICONS.directions + '<span>Get directions</span>';
      mapLink.setAttribute("rel", "noopener");
      actions.appendChild(mapLink);
    }
    if (actions.children.length) details.appendChild(actions);
  }

  function addOpenStatus(details) {
    var text = details.textContent;
    var parts = new Intl.DateTimeFormat("en-ZA", {
      timeZone: "Africa/Johannesburg",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    var weekend = values.weekday === "Sat" || values.weekday === "Sun";
    var pattern = weekend
      ? /Sat\s*-\s*Sun\s*:\s*(\d{2}):(\d{2})\s*-\s*(\d{2}):(\d{2})/i
      : /Mon\s*-\s*Fri\s*:\s*(\d{2}):(\d{2})\s*-\s*(\d{2}):(\d{2})/i;
    var hours = text.match(pattern);
    if (!hours) return;
    var now = Number(values.hour) * 60 + Number(values.minute);
    var opens = Number(hours[1]) * 60 + Number(hours[2]);
    var closes = Number(hours[3]) * 60 + Number(hours[4]);
    var open = now >= opens && now < closes;
    var status = document.createElement("p");
    status.className = "pp-store__status " + (open ? "is-open" : "is-closed");
    status.innerHTML = '<span></span>' + (open ? "Open now &middot; until " + hours[3] + ":" + hours[4] : "Closed now &middot; opens " + hours[1] + ":" + hours[2]);
    details.querySelector(".pp-store__name").insertAdjacentElement("afterend", status);
  }

  function buildStore(group, position) {
    var id = "store-" + slugify(group.title);
    var location = STORE_LOCATIONS[slugify(group.title)];
    var card = document.createElement("section");
    var details = document.createElement("div");
    var map = document.createElement("div");
    var heading = document.createElement("h2");
    var number = document.createElement("span");
    card.className = "pp-store";
    card.id = id;
    card.setAttribute("data-store-number", String(position).padStart(2, "0"));
    card.setAttribute("role", "tabpanel");
    card.setAttribute("aria-labelledby", "tab-" + id);
    details.className = "pp-store__details";
    details.setAttribute("data-store-number", String(position).padStart(2, "0"));
    map.className = "pp-store__map";
    heading.className = "pp-store__name";
    number.className = "pp-store__number";
    number.textContent = String(position).padStart(2, "0") + " / 05";
    heading.textContent = group.title;
    details.appendChild(number);
    details.appendChild(heading);

    group.nodes.forEach(function (node) {
      var iframe = node.nodeType === 1 && (node.tagName === "IFRAME" ? node : node.querySelector("iframe"));
      if (iframe) {
        iframe.removeAttribute("style");
        if (location) iframe.src = location.embedUrl;
        iframe.setAttribute("loading", "lazy");
        iframe.setAttribute("title", group.title + " map");
        map.appendChild(iframe);
      } else if (node.nodeType === 1 && !node.textContent.trim()) {
        return;
      } else if (!(node.nodeType === 3 && !node.textContent.trim())) {
        details.appendChild(node);
      }
    });
    var caption = document.createElement("div");
    caption.className = "pp-store__map-caption";
    caption.innerHTML = ICONS.pin + '<span><strong>' + group.title + '</strong>Western Cape</span>';
    if (map.children.length) map.appendChild(caption);
    addOpenStatus(details);
    addActions(details, location);
    card.appendChild(details);
    if (map.children.length) card.appendChild(map);
    return card;
  }

  function buildDispatch(group, directory) {
    var panel = document.createElement("aside");
    var copy = document.createElement("div");
    var title = document.createElement("h2");
    var action = document.createElement("a");
    panel.className = "pp-stores__dispatch";
    copy.className = "pp-stores__dispatch-copy";
    title.textContent = group.title;
    copy.appendChild(title);
    group.nodes.forEach(function (node) {
      if (node.nodeType === 1 && node.textContent.trim()) copy.appendChild(node);
    });
    var phone = copy.textContent.match(/(?:0\d{2})\s*\d{3}\s*\d{4}/);
    action.className = "pp-store__action pp-store__action--primary";
    action.href = phone ? "tel:" + phone[0].replace(/\s/g, "") : "mailto:info@petplus.co.za";
    action.innerHTML = ICONS.headset + '<span>Contact dispatch</span>';
    panel.appendChild(copy);
    panel.appendChild(action);
    directory.parentNode.insertBefore(panel, directory);
  }

  function initStores() {
    var source = document.querySelector(".pp-stores__source");
    var index = document.querySelector(".pp-stores__index");
    var directory = document.querySelector(".pp-stores__directory");
    if (!source || !index || !directory) return;
    var groups = [];
    var current = null;
    Array.prototype.slice.call(source.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === "H2") {
        current = { title: node.textContent.trim(), nodes: [] };
        groups.push(current);
      } else if (current) current.nodes.push(node);
    });
    if (groups.length < 2) return;
    source.innerHTML = "";
    source.classList.add("pp-stores__panels");
    buildDispatch(groups.shift(), directory);

    groups.forEach(function (group, position) {
      var card = buildStore(group, position + 1);
      var button = document.createElement("button");
      button.type = "button";
      button.className = "pp-stores__tab";
      button.id = "tab-" + card.id;
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", card.id);
      button.innerHTML = '<span>' + String(position + 1).padStart(2, "0") + '</span>' + group.title + ICONS.chevron;
      index.appendChild(button);
      source.appendChild(card);
    });

    var tabs = Array.prototype.slice.call(index.querySelectorAll(".pp-stores__tab"));
    var panels = Array.prototype.slice.call(source.querySelectorAll(".pp-store"));
    function selectStore(selected) {
      tabs.forEach(function (tab, i) {
        var active = tab === selected;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
        tab.setAttribute("tabindex", active ? "0" : "-1");
        panels[i].hidden = !active;
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () { selectStore(tab); });
      tab.addEventListener("keydown", function (event) {
        if (!["ArrowDown", "ArrowRight", "ArrowUp", "ArrowLeft"].includes(event.key)) return;
        event.preventDefault();
        var direction = event.key === "ArrowDown" || event.key === "ArrowRight" ? 1 : -1;
        var next = tabs[(i + direction + tabs.length) % tabs.length];
        selectStore(next);
        next.focus();
      });
    });
    index.setAttribute("role", "tablist");
    selectStore(tabs[0]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initStores);
  else initStores();
})();
